import { isPhone, isWeb, machineStatus, machineStatusColorName, ncFileStatuses } from '@helpers';
import { NcFileBatchEventType } from '@v2/pages/common/enums';

export const DURATION_COLORS = {
  [NcFileBatchEventType.ACTIVE]: machineStatusColorName[machineStatus.ACTIVE],
  [NcFileBatchEventType.CHANGE]: machineStatusColorName[machineStatus.CHANGE],
  [NcFileBatchEventType.SETUP]: machineStatusColorName[machineStatus.SETUP],
  [NcFileBatchEventType.TRACE]: 'Label/Light/Primary', // fallback
  [NcFileBatchEventType.CYCLE]: 'Label/Light/Primary',
} as const;

export const ORDER_BY = 'StartedOn desc';

export const CYCLE_EVENT_LEVELS = [NcFileBatchEventType.CYCLE, NcFileBatchEventType.ACTIVE, NcFileBatchEventType.CHANGE];

export const LIMIT = isWeb ? 100 : !isPhone ? 50 : 30;

export const MARKER_SIZE = 14;
export const DOT_SIZE = 4;

export const HARDCODED_MAX_TIME_FOR_MACHINE_EVENTS = 3600;

export const NC_FILE_STATUSES_FOR_UNIQUE_TRACE_EVENT = [ncFileStatuses.Ignored, ncFileStatuses.Change, ncFileStatuses.Setup];

export const EVENT_POPUP_STYLES = {
  width: 480,
  top: 22,
};

export const DEFAULT_EVENT_KEY_FIELDS = ['sequenceNumber', 'cycleNumber', 'batchSequenceNumber'] as const;

export const AMOUNT_OF_TIME_EVENT_DELAYED_IN_MINS = 30;

export const ACCORDION_FETCH_TIMEOUT_MS = 30000;